import { defineStore } from "pinia";

export const useModalStore = defineStore("use-modal-store", {
  state: (): {
    alertModal: boolean
  } => ({
    alertModal: false,
  }),
  actions: {
    changeAlertModalStatus(status: boolean) {
      this.alertModal = status;
    },
  },
});
